export const uploadMessages = [
  // Stage 1: Starting
  {
    stage: 'starting',
    message: 'Your video is a bit large, we need to compress it.',
  },
  { stage: 'starting', message: 'Getting things ready…' },
  { stage: 'starting', message: 'Preparing your video for upload.' },
  {
    stage: 'starting',
    message: 'Compression started—making your file smaller.',
  },
  {
    stage: 'starting',
    message: 'We’re packing your video neatly for the trip.',
  },
  {
    stage: 'starting',
    message: 'Video is queued and upload is about to begin.',
  },
  { stage: 'starting', message: 'Starting the journey to the cloud…' },

  // Stage 2: Processing
  { stage: 'processing', message: 'Uploading your video—please wait.' },
  { stage: 'processing', message: 'Your video is making steady progress.' },
  { stage: 'processing', message: 'Sending video data… bit by bit.' },
  { stage: 'processing', message: 'Video compression still in progress.' },
  { stage: 'processing', message: 'Carefully transferring your video.' },
  { stage: 'processing', message: 'Please hang tight—we’re halfway there!' },
  {
    stage: 'processing',
    message: 'Still working—thank you for your patience.',
  },
  { stage: 'processing', message: 'Your video is moving safely to the cloud.' },
  {
    stage: 'processing',
    message: 'No need to refresh—we’ve got this covered.',
  },
  {
    stage: 'processing',
    message: 'Optimizing your video for smooth playback.',
  },
  {
    stage: 'processing',
    message: 'We’re crunching the numbers behind the scenes.',
  },
  { stage: 'processing', message: 'Your video is over the halfway mark!' },

  // Stage 3: Almost Done
  { stage: 'almost_done', message: 'Video upload is nearly complete.' },
  {
    stage: 'almost_done',
    message: 'Final chunks of your video are being sent.',
  },
  {
    stage: 'almost_done',
    message: 'We’re wrapping things up—please stay with us.',
  },
  {
    stage: 'almost_done',
    message: 'Almost there—your video is in the final stages.',
  },
  { stage: 'almost_done', message: 'Doing the finishing touches…' },
  {
    stage: 'almost_done',
    message: 'Your upload is seconds away from completion.',
  },
  { stage: 'almost_done', message: 'Thanks for waiting—just about done!' },

  // Stage 4: Completed Soon
  { stage: 'finalizing', message: 'Finalizing your video upload…' },
  { stage: 'finalizing', message: 'Securing your video in the cloud.' },
  { stage: 'finalizing', message: 'Preparing your video for playback.' },
  {
    stage: 'finalizing',
    message: 'Your upload is complete—processing final checks.',
  },
  { stage: 'finalizing', message: 'Done! Your video is now safely uploaded.' },
];
